import Button from '@amzn/awsui-components-core/button';
import React from 'react';
import { useVersionDropdown } from 'src/components/star-grid/hooks/useVersionDropdown';
import { versionCountText } from 'src/components/star-grid/utils/versionPickerPresentation';
import styles from 'src/components/star-grid/components/styles/ReportVersionSelector.module.scss';

type State = ReturnType<typeof useVersionDropdown>;

export const ReportVersionDateActions: React.FC<{ readonly state: State }> = ({ state }) => (
  <div className={styles.dateActions}>
    <span className={styles.rangePreview} aria-live="polite">
      {state.draftSnapshotCount === undefined
        ? state.text('versionCompleteRange')
        : versionCountText(state.text('versionDraftCount'), state.draftSnapshotCount)}
    </span>
    <Button formAction="none" variant="link" onClick={state.dates.dismiss} data-testid="version-cancel-dates">
      {state.text('versionCancelDates')}
    </Button>
    <Button formAction="none" variant="primary" disabled={!state.dates.valid} onClick={state.dates.apply} data-testid="version-apply-dates">
      {state.text('versionApplyDates')}
    </Button>
  </div>
);
